export const handleError = (error: any) => {
  const message = error.message || error.response?.data?.message;
  if (message) {
    return message;
  } else {
    return [error].flat().join('\n');
  }
};
